import type { Wallet, } from "@bracket/prisma";
import type { AllUserData, } from "@bracket/types";
import * as G from "@globals";
import type { IBracketStore, } from "@types";
import { gql, } from "../gql";



export const userData = async ( store: IBracketStore, ): Promise<Wallet & { user: AllUserData }> => {
	store;
	const { address, } = G.wallet.getBracketWallet();
	const response = await gql<{ wallet:Wallet & { user: AllUserData; }}>("USER_DATA", address as string);
	if(response?.wallet) {
		return response.wallet;
	}
	throw new Error("wallet::userData:: failed to fetch user data");
};
